import React from "react";

export default function UnitSwitcher({ unit, onChange }) {
  return (
    <div className="flex items-center justify-end gap-2 text-xs">
      <span style={{ color: "#9a93b0" }}>واحد مبالغ:</span>
      {["rial", "toman"].map((u) => (
        <button
          key={u}
          onClick={() => onChange(u)}
          className={`px-3 py-1 rounded-full text-neutral-200 ${unit === u ? "bg-primary" : "bg-neutral-800"}`}
        >
          {u === "toman" ? "تومان" : "ریال"}
        </button>
      ))}
    </div>
  );
}
